import React from 'react';
import { Switch, Box, Typography, styled } from '@mui/material';

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 60,
  height: 34,
  padding: 7,
  '& .MuiSwitch-switchBase': {
    padding: 1,
    transform: 'translateX(-2px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(25px)',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.red.main,
        opacity: 1,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 28,
    height: 28,
    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
  },
  '& .MuiSwitch-track': {
    borderRadius: 20,
    backgroundColor: '#ccc',
    opacity: 1,
  },
}));

const ToggleSwitch = ({ checked, onCheck, checkedText,unCheckedText }) => {
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <CustomSwitch checked={checked} onChange={(e) => onCheck(e.target.checked)} />
      <Typography variant="body2" width={"100px"}>{checked ? checkedText : unCheckedText}</Typography>
    </Box>
  );
};

export default ToggleSwitch;
